"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const pause = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-pause` : '') + (description ? ` desc-pause` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-pause"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-pause"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M22.563 16H1.938l-.112.008c-.483.07-.826.495-.826.992 0 .548.415 1 .938 1h20.625l.111-.008c.483-.07.826-.495.826-.992 0-.548-.415-1-.938-1zm0-10H1.938l-.112.008C1.343 6.078 1 6.503 1 7c0 .548.415 1 .938 1h20.625l.111-.008c.483-.07.826-.495.826-.992 0-.548-.415-1-.938-1z",
    transform: "rotate(90 12.25 12)"
  })));
};
var _default = exports.default = pause;